import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UserService } from '../../core/services/user/user.service';
import { ContractService } from '../../core/services/wallet/wallet.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, from, map, switchMap, tap } from 'rxjs';
import { Client, UserContract } from '@mlc/types';

@UntilDestroy()
@Component({
    selector: 'app-wallet-selector',
    templateUrl: './wallet-selector.component.html',
    styleUrls: ['./wallet-selector.component.scss'],
    standalone: false
})
export class WalletSelectorComponent  implements OnInit {

  public selectedWalletControl: FormControl = new FormControl();
  public isModalOpen: boolean = false;
  public selectedWalletName?: string;
  public selectedWalletLogo?: string;
  public numberOfWallet: number = 0;
  public user?: Client;

  constructor(private userService: UserService, private contractService: ContractService) {}

  ngOnInit() {
    this.selectedWalletControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(walletId => this.contractService.setCurrentWallet(walletId) );

    this.userService.get().pipe(
      untilDestroyed(this),
      filter((user): user is Client => !!user),
      switchMap((user: Client) => {
        this.user = user;
        const wallets = [
          ...(user.userCompany?.productWallets ?? []),
          ...(user.productWallets ?? []),
        ] as (UserContract & { id: number })[];

        this.numberOfWallet = wallets.length;

        return from(this.contractService.getCurrentWallet());
      })
    ).subscribe((currentId: number | undefined) => {
      const walletId: number | undefined =
        currentId ??
        this.user?.productWallets?.[0]?.id ??
        this.user?.userCompany?.productWallets?.[0]?.id;

      if (walletId) {
        this.contractService.setCurrentWallet(walletId);
      }
    });


    this.contractService.currentWallet$
      .pipe(untilDestroyed(this))
      .subscribe(walletId => {
        if (walletId && this.user) {
          const wallets: (UserContract & {id: number;})[] = (this.user.userCompany?.productWallets || []).concat(this.user.productWallets ?? []);
          const wallet = wallets.find(w => w.id === walletId);
          if (wallet) {
            this.selectedWalletLogo = wallet.product.productLogo?.url;
            this.selectedWalletName = wallet.product.name;
            this.selectedWalletControl.setValue(wallet.id, { emitEvent: false });
          }
        }
      });
  }

  toggleModal() {
    this.isModalOpen = !this.isModalOpen;
  }

  selectedWalletOption(wallet: UserContract & { id: number }, toggleModal = true) {
    this.selectedWalletControl.setValue(wallet.id);
    if (toggleModal) this.toggleModal();
  }
}
